"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNavigate = void 0;
const react_router_dom_1 = require("react-router-dom");
const useNavigate = () => {
    const reactRouterNavigate = (0, react_router_dom_1.useNavigate)();
    const navigate = (to, options) => {
        if ((options === null || options === void 0 ? void 0 : options.external) && typeof to === 'string') {
            return window.location.assign(to);
        }
        if (typeof to === 'number') {
            return reactRouterNavigate(to);
        }
        return reactRouterNavigate(to, options);
    };
    return navigate;
};
exports.useNavigate = useNavigate;
//# sourceMappingURL=useNavigate.js.map